module.exports = __webpack_public_path__ + "images/David_Tellenne-fa3f2a68358a4a3c9ccd74773c3dfc05.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/David_Tellenne.png
// module id = 26
// module chunks = 0